import {
    type ApiResult,
    type BaseParams,
    type EmojiId,
    links,
    type PaginatedResult,
    type PagingParams,
    type PostParams,
    Request,
    type ResourceId,
    type TransferCodeParams,
    type TransferId,
    type TransferPostParams,
    type TransfersResponse,
} from '@app/client';

// List incoming transfers
export async function getIncomingCollection(params: BaseParams): Promise<ApiResult<TransfersResponse[]>> {
    return Request.getRequest<TransfersResponse[]>({
        ...params,
        target: links.transfers().collection().transfers_incoming,
    });
}

// List sent transfers
export async function getOutgoingCollection(
    params: BaseParams<PagingParams> & { user_id?: ResourceId },
): Promise<ApiResult<PaginatedResult<TransfersResponse>>> {
    return Request.getRequest<PaginatedResult<TransfersResponse>>({
        ...params,
        target: links.transfers().collection().transfers,
    });
}

// Initiate new transfer
export async function create(
    params: BaseParams & PostParams<TransferPostParams>,
): Promise<ApiResult<TransfersResponse>> {
    return Request.postRequest<TransfersResponse>({
        ...params,
        target: links.transfers().collection().transfers,
        settings: {
            ...params.settings,
        },
    });
}

// Delete transfer
export async function remove(params: BaseParams & { id: TransferId }): Promise<ApiResult<TransfersResponse>> {
    return Request.deleteRequest<TransfersResponse>({
        ...params,
        target: links.transfers().single(params.id).single,
    });
}

// sender accepts code, receiver OTP is sent out
export async function acceptSenderOTP(
    params: BaseParams & PostParams<TransferCodeParams> & { id: TransferId },
): Promise<ApiResult<TransfersResponse>> {
    return Request.postRequest<TransfersResponse>({
        ...params,
        target: links.transfers().single(params.id).sender_accept,
    });
}

// receiver accepts, transfer complete
export async function acceptReceiverOTP(
    params: BaseParams & PostParams<TransferCodeParams> & { id: TransferId },
): Promise<ApiResult<EmojiId[]>> {
    return Request.postRequest<EmojiId[]>({
        ...params,
        target: links.transfers().single(params.id).receiver_accept,
    });
}

// resend OTP
export async function resendOTP(
    params: BaseParams & PostParams & { id: TransferId },
): Promise<ApiResult<Record<string, unknown>>> {
    return Request.postRequest<Record<string, unknown>>({
        ...params,
        target: links.transfers().single(params.id).resend_code,
    });
}
